import { render } from "./BarresRouges.vue?vue&type=template&id=39f33370"
import script from "./BarresRouges.vue?vue&type=script&lang=js"
export * from "./BarresRouges.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__